export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/photogallery/addEventYear',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allYears'],
       
    })
